import React from 'react';

const PasswordStrengthIndicator = ({ password, showTitle = true }) => {
  if (!password) return null;

  const requirements = [
    {
      text: 'At least 8 characters',
      test: password.length >= 8
    },
    {
      text: 'One uppercase letter',
      test: /[A-Z]/.test(password)
    },
    {
      text: 'One lowercase letter',
      test: /[a-z]/.test(password)
    },
    {
      text: 'One number',
      test: /[0-9]/.test(password)
    },
    {
      text: 'One special character',
      test: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
    }
  ];

  return (
    <div className="password-requirements" style={{ marginTop: '8px', fontSize: '0.85rem' }}>
      {showTitle && (
        <div style={{ marginBottom: '6px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          Password Requirements:
        </div>
      )}
      {requirements.map((requirement, index) => (
        <div key={index} className={`requirement ${requirement.test ? 'met' : 'unmet'}`}>
          <i className={`fas ${requirement.test ? 'fa-check' : 'fa-times'}`}></i>
          {requirement.text}
        </div>
      ))}
    </div>
  );
};

export default PasswordStrengthIndicator;
